import Udesk from 'Udesk';
import React, { FC, memo, useMemo } from 'react';
import { Select } from 'udesk-ui';

interface TemplateProps {
    value?: string;
    onChange?: (value: TemplateProps['value']) => void;
    isSales?: boolean;
    disabled?: boolean;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, isSales, disabled } = props;

    console.log(props, 'props');

    const _value = useMemo(() => {
        return value ? value.split(',') : [];
    }, [value]);

    return (
        <Select<string[]>
            options={(isSales ? Udesk.enums.saleApplyRoles : Udesk.enums.applyRoles).map((item) => {
                return {
                    value: item.id,
                    label: item.name,
                };
            })}
            mode="multiple"
            maxTagCount={1}
            value={_value}
            onChange={(v) => onChange?.(v.join(','))}
            disabled={disabled}
            style={{ width: 200 }}
        />
    );
});

export default Template;
